import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	tooltipMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltipMessageBeforeShortcut: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tooltipMessage: {
		id: 'filter-refinement.search-field.tooltip-message',
		defaultMessage: 'Search <inline>F</inline>',
		description:
			'Tooltip message shown when hovering over the search field, indicating the keyboard shortcut F to focus on search field',
	},
	tooltipMessageBeforeShortcut: {
		id: 'filter-refinement.search-field.tooltip-message-before-shortcut',
		defaultMessage: 'Search',
		description:
			'Tooltip message shown when hovering over the search field. It will be displayed before the keyboard shortcut.',
	},
});
export default messages;
